import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import logger from '../../../../utils/logger';
import aiNativeBehaviorEvaluator from '../../../../nativeBehaviors/aiNativeBehaviorEvaluator';
import { ensureLimitedResultsPrefix } from './qualityAgentHelpers';

/**
 * Custom hook for generating quality agent check suggestions
 * @param {Array} checksArray - Array of existing checks
 * @param {Object} content - Form content with title and formType
 * @param {Function} setSuggestions - State setter for suggestions
 * @param {Function} setIsGenerating - State setter for generating state
 * @param {Function} notificationActions - Notification actions
 * @param {boolean} pendingOperation - Whether a pending operation is in progress
 * @returns {Function} - handleGenerate function
 */
const useGenerateChecks = _ref => {
  let checksArray = _ref.checksArray,
    content = _ref.content,
    setSuggestions = _ref.setSuggestions,
    setIsGenerating = _ref.setIsGenerating,
    notificationActions = _ref.notificationActions,
    pendingOperation = _ref.pendingOperation;
  const handleGenerate = useCallback(async userRequest => {
    if (pendingOperation) {
      notificationActions.info({
        message: 'Waiting for changes to save.'
      }, {
        autoClose: 3000
      });
      return;
    }
    setIsGenerating(true);
    setSuggestions([]);
    try {
      var _content$formType;
      // Build input checks with limited results prefix
      const formTitle = (content === null || content === void 0 ? void 0 : content.title) || '';
      const formTypeName = (content === null || content === void 0 || (_content$formType = content.formType) === null || _content$formType === void 0 ? void 0 : _content$formType.name) || '';

      // Ensure all queries have the correct limited results prefix
      const inputChecks = checksArray.map(check => _objectSpread(_objectSpread({}, check), {}, {
        query: ensureLimitedResultsPrefix(check.query || '', formTypeName, formTitle)
      }));

      // Call qualityAgentGenerateChecks directly via AI service
      const ignoredChecks = [];
      const response = await aiNativeBehaviorEvaluator.qualityAgentGenerateChecks(inputChecks, userRequest || '', ignoredChecks);

      // Store suggestions in local state (transient)
      const generatedChecks = response.checks;
      setSuggestions(generatedChecks || []);
    } catch (error) {
      logger('Error generating suggestions:', error);
      notificationActions.info({
        message: "Error generating suggestions: ".concat(error.message || 'Unknown error')
      }, {
        autoClose: 5000
      });
    } finally {
      setIsGenerating(false);
    }
  }, [checksArray, content, setSuggestions, setIsGenerating, notificationActions, pendingOperation]);
  return handleGenerate;
};
export default useGenerateChecks;